import api from '@/api/index'
import * as types from '../mutation-types'

// initial state
const state = {
  condition: {
    condition: {},
    excondition: {},
    master_inverter: [],
    master_module: [],
    schedule_file: [],
    reference_file: []
  },
  recent_smp_price: [],
  recent_rec_price: []
}

// getters
const getters = {
  condition: state => state.condition,
  recent_smp_price: state => state.recent_smp_price,
  recent_rec_price: state => state.recent_rec_price
}

// actions
const actions = {
  getUserCondition ({ commit }) {
    return new Promise((resolve, reject) => {
      api.getUserCondition(response => {
        // error 발생 시
        if (response.error) {
          reject(Error(response))
        } else {
          const condition = response
          commit(types.USER_CONDITION, { condition })
          resolve(response)
        }
      })
    })
  },

  saveCondition ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.saveCondition(data, response => {
        if (response.error) {
          reject(Error(response))
        } else {
          const condition = {
            condition: response.condition,
            excondition: response.excondition,
            master_inverter: response.master_inverter,
            master_module: response.master_module,
            schedule_file: response.schedule_file,
            reference_file: response.reference_file
          }
          commit(types.USER_CONDITION, { condition })
          resolve(response)
        }
      })
    })
  },

  getRecentInputPrice ({ commit }) {
    commit(types.GET_RECENT_INPUT_PRICE)
  },

  setRecentInputPrice ({ commit }, params) {
    commit(types.SET_RECENT_INPUT_PRICE, { params })
  }
}

// mutations
const mutations = {
  [types.USER_CONDITION] (state, { condition }) {
    state.condition = condition
  },
  [types.GET_RECENT_INPUT_PRICE] (state) {
    const getSavedPrice = (target = '') => {
      let savedPrice = localStorage.getItem(target)

      // 로컬 스토리지에 저장된 값이 있을 경우 해당 값을 파싱한다.
      if (savedPrice) {
        savedPrice = JSON.parse(savedPrice)
      } else {
        savedPrice = []
      }

      return savedPrice
    }

    // 로컬스토리지에 저장된 SMP, REC 가격 항목들을 가져온다.
    state.recent_smp_price = getSavedPrice('smp_price')
    state.recent_rec_price = getSavedPrice('rec_price')
  },
  [types.SET_RECENT_INPUT_PRICE] (state, { params }) {
    const {target, price} = params
    let savedPrice = localStorage.getItem(target)

    // 로컬 스토리지에 저장된 값이 있을 경우 해당 값을 파싱한다.
    if (savedPrice) {
      savedPrice = JSON.parse(savedPrice)
    } else {
      savedPrice = []
    }

    // new Set을 활용하여 배열안에 중복값을 제거한 후 최대 5개 값만 할당한다.
    let mergePrice = Array.from(new Set([price, ...savedPrice])).slice(0, 5)

    // 가공된 SMP, REC 가격 정보를 로컬스토리지와 Vuex 스토어에 저장한다.
    localStorage.setItem(target, JSON.stringify(mergePrice))
    state[`recent_${target}`] = mergePrice
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/condition.js